export const mutations = {
  STORE_CUSTOMRELEASES(state, customreleases) {
    state.customreleases = customreleases;
  },
  STORE_CUSTOMRELEASE_UPDATE(state, customreleaseId) {
    let Customrelease = state.customreleases.find(function(customrelease) {
      return customrelease.id === customreleaseId;
    });
    state.systemCustomrelease = Customrelease;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/customreleases/mutations.js